import React, { useState, useEffect } from "react";
import { colors } from "../../../../themes/Colors";
import {
  BaseButtons,
  CheckInput,
  TextInputField,
  TextInputFieldArea,
} from "../../../common-components";
import { useNavigate } from "react-router-dom";
import useWindowDimensions from "../../../../dynamic-sizing-functions/get-diemensions/UseWindowDiemensions";

const BecomeAgent = ({
  display,
  setAgentPopUp,
  setLoading,
  setToastPop,
  setPopUpTitle,
  setMessage,
}) => {
  const { width, height } = useWindowDimensions();
  const [applicationSent, setApplicationSent] = useState(false);

  //admin user information
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [cellNumber, setCellNumber] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  //company information
  const [companyName, setCompanyName] = useState("");
  const [companySlogan, setCompanySlogan] = useState("");
  const [companyContactNumber, setCompanyContactNumbe] = useState("");
  const [companyEmail, setCompanyEmail] = useState("");
  const [companyWebsite, setCompanyWebsite] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [companyDescription, setCompanyDescription] = useState("");
  //services

  const [finesCheck, setFinesCheck] = useState(false);
  const [liscensingCheck, setLiscensingCheck] = useState(false);
  const [sales, setSales] = useState(false);
  const [valuation, setValuation] = useState(false);
  const [spares, setSpares] = useState(false);
  const [services, setServices] = useState(false);
  const [autoFitment, setAutoFitment] = useState(false);
  const [towing, setTowing] = useState(false);

  const [termsAndConditions, setTermsAndConditions] = useState(false);

  let companyServicesArray = [
    {
      serviceType: "FINES",
      value: finesCheck,
    },
    {
      serviceType: "LISCENSING",
      value: liscensingCheck,
    },
    {
      serviceType: "SALES",
      value: sales,
    },
    {
      serviceType: "VALUATION",
      value: valuation,
    },
    {
      serviceType: "SPARES",
      value: spares,
    },
    {
      serviceType: "SERVICES",
      value: services,
    },
    {
      serviceType: "AUTO-FITMENT",
      value: autoFitment,
    },
    {
      serviceType: "TOWING",
      value: towing,
    },
  ];

  const navigate = useNavigate();

  const regsiterHandler = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        // process.env.REACT_APP_BACKEND_URL + "/agency/createAgencyRequest",
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/agency/createAgencyRequest",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            firstName: firstName,
            lastName: lastName,
            cellNumber: cellNumber,
            email: email,
            password: password,

            // company information
            companyName: companyName,
            companySlogan: companySlogan,
            companyEmail: companyEmail,
            companyContactName: firstName + " " + lastName,
            companyAddress: companyAddress,
            companyDescription: companyDescription,
            companyWebsite,
            companyContactNumber: companyContactNumber,

            //services
            companyServices: companyServicesArray,

            //terms and condtitions
            acceptedTAndC: termsAndConditions,
          }),
        }
      );

      const respnseData = await response.json();
      console.log("response", respnseData);
      if (respnseData.success) {
        setLoading(false);
        setToastPop(true);
        setMessage("Your application has been sent...");
        setPopUpTitle("SUCCESS");

        setApplicationSent(true);
      } else {
        setPopUpTitle("FAILURE");
        setToastPop(true);
        setMessage(respnseData.message);
        setLoading(false);
      }
    } catch (err) {}
  };

  return (
    <div
      style={{
        position: "fixed",
        width: "100%",
        height: display ? "100%" : 0,
        backgroundColor: colors.greenLight50,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        bottom: 0,
        transition: "all 0.3s",
      }}
    >
      <div
        style={{
          minHeight: height,
          maxHeight: height,
          minWidth: width,
          maxWidth: width,
          borderRadius: 10,
          backgroundColor: colors.secondaryGrey,
          WebkitBoxShadow: "-2px 20px 40px -10px #000000",
          borderStyle: "solid",
          borderWidth: 4,
          borderColor: colors.white,
          position: "relative",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={{ position: "absolute", top: 20, left: 20 }}>
          <BaseButtons
            label={"CLOSE"}
            borderRadius={8}
            backgroundColor={colors.orangeDark}
            width={120}
            onClick={() => {
              setAgentPopUp(false);
              setApplicationSent(false);
            }}
          />
        </div>
        {applicationSent ? (
          <div
            style={{
              flex: 1,
              display: "flex",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                width: "60%",
                fontSize: 28,
                fontWeight: "bold",
                textAlign: "center",
                marginBottom: 20,
              }}
            >
              APPLICATION SUBMITTED !!!
            </div>
            <div style={{ width: "60%", textAlign: "center", fontSize: 20 }}>
              Your Application has been sent for review , This can take up to 48
              hours before you will recieve a response via email with a link for
              you to complete your profile and grant you access to the Agency
              portal...{" "}
            </div>

            <div
              style={{
                width: "60%",
                textAlign: "center",
                marginTop: 20,
                fontSize: 20,
              }}
            >
              If you have questions contact us here + 000 0000000 or read our
              documentation at www.websitelinkehere.cp.za
            </div>
            <div style={{ minHeight: 20 }} />
            <BaseButtons
              label={"GO TO LOGIN"}
              onClick={() => navigate("/agency")}
              borderRadius={8}
              backgroundColor={colors.primaryBlue}
              width={180}
            />
          </div>
        ) : (
          <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <div
              style={{
                width: "100%",
                textAlign: "center",
                fontSize: 25,
                fontWeight: "bold",
                color: colors.greenDark,
                marginTop: 25,
                marginBottom: 25,
              }}
            >
              WANT TO BECOME A AGENCY ?
            </div>
            <div style={{ flex: 1, display: "flex" }}>
              <div
                style={{
                  flex: 0.5,

                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    height: "95%",
                    maxHeight: height - 100,
                    width: "95%",
                    backgroundColor: colors.white,
                    borderRadius: 10,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    WebkitBoxShadow: "0px 0px 7px 2px #00000050",
                  }}
                >
                  <div
                    style={{
                      fontSize: 20,
                      fontWeight: "bold",
                      marginBottom: 20,
                      // color: colors.greenDark,
                      marginTop: 20,
                    }}
                  >
                    AGENCY INFORMATION
                  </div>
                  <div
                    style={{
                      flex: 1,

                      width: "90%",
                      overflowY: "scroll",
                      overflowX: "hidden",
                      marginBottom: 20,
                      maxHeight: height - 250,
                      minHeight: height - 250,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      scrollbarWidth: "none",
                    }}
                  >
                    <div>
                      This will be your basic information that will aloow you to
                      apply for agency and after approval the rest of the
                      process can be completed
                    </div>
                    <div
                      style={{
                        fontSize: 16,
                        fontWeight: "bold",
                        width: "100%",
                        marginTop: 20,
                        marginBottom: 10,
                      }}
                    >
                      ADMIN USER INFORMATION
                    </div>
                    <TextInputField
                      labelTitle={"First name"}
                      width={"100%"}
                      size={"90%"}
                      mini={true}
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                    <TextInputField
                      labelTitle={"Last name"}
                      width={"100%"}
                      size={"90%"}
                      mini={true}
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                    <TextInputField
                      labelTitle={"Cell number"}
                      width={"100%"}
                      size={"90%"}
                      mini={true}
                      value={cellNumber}
                      onChange={(e) => setCellNumber(e.target.value)}
                    />
                    <TextInputField
                      labelTitle={"Email"}
                      width={"100%"}
                      size={"90%"}
                      mini={true}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <TextInputField
                      labelTitle={"Password"}
                      width={"100%"}
                      size={"90%"}
                      mini={true}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <TextInputField
                      labelTitle={"Confirm password "}
                      width={"100%"}
                      size={"90%"}
                      mini={true}
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    <div
                      style={{
                        fontSize: 16,
                        fontWeight: "bold",
                        width: "100%",
                        marginTop: 20,
                        marginBottom: 10,
                      }}
                    >
                      COMPANY INFORMATION
                    </div>
                    <TextInputField
                      labelTitle={"Company name"}
                      width={"100%"}
                      size={"90%"}
                      mini={true}
                      value={companyName}
                      onChange={(e) => setCompanyName(e.target.value)}
                    />
                    <TextInputField
                      labelTitle={"Company slogan"}
                      width={"100%"}
                      size={"90%"}
                      mini={true}
                      value={companySlogan}
                      onChange={(e) => setCompanySlogan(e.target.value)}
                    />
                    <TextInputField
                      labelTitle={"Company contact number"}
                      width={"100%"}
                      size={"90%"}
                      mini={true}
                      value={companyContactNumber}
                      onChange={(e) => setCompanyContactNumbe(e.target.value)}
                    />
                    <TextInputField
                      labelTitle={"Company email"}
                      width={"100%"}
                      size={"90%"}
                      mini={true}
                      value={companyEmail}
                      onChange={(e) => setCompanyEmail(e.target.value)}
                    />

                    <TextInputField
                      labelTitle={"Company website"}
                      width={"100%"}
                      size={"90%"}
                      mini={true}
                      value={companyWebsite}
                      onChange={(e) => setCompanyWebsite(e.target.value)}
                    />
                    <TextInputFieldArea
                      labelTitle={"Company address"}
                      width={"100%"}
                      size={"90%"}
                      mini={true}
                      height={150}
                      value={companyAddress}
                      onChange={(e) => setCompanyAddress(e.target.value)}
                    />
                    <TextInputFieldArea
                      labelTitle={"Company description"}
                      width={"100%"}
                      size={"90%"}
                      mini={true}
                      height={150}
                      value={companyDescription}
                      onChange={(e) => setCompanyDescription(e.target.value)}
                    />
                    {/* <div
                      style={{
                        fontSize: 16,
                        fontWeight: "bold",
                        width: "100%",
                        marginTop: 20,
                        marginBottom: 10,
                      }}
                    >
                      SERVICES YOU WOULD LIKE TO OFFER
                    </div> */}
                    {/* <CheckInput
                      label={"FINES"}
                      selected={finesCheck}
                      onClick={() => setFinesCheck(finesCheck ? false : true)}
                    />
                    <div style={{ minHeight: 10 }} />
                    <CheckInput
                      label={"LISCENSING"}
                      selected={liscensingCheck}
                      onClick={() =>
                        setLiscensingCheck(liscensingCheck ? false : true)
                      }
                    />
                    <div style={{ minHeight: 10 }} /> */}
                    {/* <CheckInput
                      label={"SALES"}
                      selected={sales}
                      onClick={() => setSales(sales ? false : true)}
                    />
                    <div style={{ minHeight: 10 }} />
                    <CheckInput
                      label={"VALUATIONS"}
                      selected={valuation}
                      onClick={() => setValuation(valuation ? false : true)}
                    />
                    <div style={{ minHeight: 10 }} />
                    <CheckInput
                      label={"SPARES"}
                      selected={spares}
                      onClick={() => setSpares(spares ? false : true)}
                    />
                    <div style={{ minHeight: 10 }} />
                    <CheckInput
                      label={"SERVICES"}
                      selected={services}
                      onClick={() => setServices(services ? false : true)}
                    /> */}
                    {/* <div style={{ minHeight: 10 }} />
                    <CheckInput
                      label={"AUO-FITMENT"}
                      selected={autoFitment}
                      onClick={() => setAutoFitment(autoFitment ? false : true)}
                    />
                    <div style={{ minHeight: 10 }} />
                    <CheckInput
                      label={"TOWING"}
                      selected={towing}
                      onClick={() => setTowing(towing ? false : true)}
                    /> */}
                    <div
                      style={{
                        fontSize: 16,
                        fontWeight: "bold",
                        width: "100%",
                        marginTop: 20,
                        marginBottom: 10,
                      }}
                    >
                      TERMS AND CONDITIONS
                    </div>
                    <CheckInput
                      label={"AGREE TO TERMS & CONDITIONS"}
                      selected={termsAndConditions}
                      onClick={() =>
                        setTermsAndConditions(termsAndConditions ? false : true)
                      }
                    />
                    <div style={{ minHeight: 20 }} />
                    <BaseButtons
                      label={"SEND APPLICATION"}
                      backgroundColor={colors.greenDark}
                      width={"90%"}
                      borderRadius={8}
                      onClick={() => regsiterHandler()}
                    />
                    <div style={{ minHeight: 20 }} />
                  </div>
                </div>
              </div>
              <div
                style={{
                  flex: 0.5,

                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    height: "95%",
                    width: "95%",

                    borderRadius: 8,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      fontSize: 20,
                      fontWeight: "bold",
                      marginBottom: 20,
                      marginTop: 20,
                      width: "85%",
                      textAlign: "left",
                    }}
                  >
                    ABOUT BECOMING AN AGENCY
                  </div>
                  <div style={{ width: "90%", display: "flex" }}>
                    <div
                      style={{
                        flex: 1,
                        //   borderStyle: "solid",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        overflow: "hidden",
                        maxHeight: 300,
                        fontSize: 13,
                      }}
                    >
                      <div style={{ width: "90%" }}>
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book. It has
                        survived not only five centuries, but also the leap into
                        electronic typesetting, remaining essentially unchanged.
                        It was popularised in the 1960s with the release of
                        Letraset sheets containing Lorem Ipsum passages.It was
                        popularised in the 1960s with the release of Letraset
                        sheets containing Lorem Ipsum passages.
                      </div>
                    </div>
                    <img
                      alt="agent"
                      src={require("./agent.png")}
                      style={{ height: 280 }}
                    />
                  </div>
                  <div
                    style={{
                      flex: 1,

                      width: "90%",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        flex: 1,

                        width: "100%",
                        marginBottom: 20,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "95%",
                          fontSize: 18,
                          fontWeight: "bold",
                          marginBottom: 10,
                        }}
                      >
                        SERVICE'S AVALIBLE
                      </div>

                      <div style={{ width: "95%" }}>
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book.
                      </div>
                      {/* <div
                        style={{
                          width: "95%",
                          marginTop: 10,
                          marginBottom: 10,
                        }}
                      >
                        - SERVICES
                      </div>
                      <div style={{ width: "95%", marginBottom: 10 }}>
                        - LISCENSING
                      </div>
                      <div style={{ width: "95%", marginBottom: 10 }}>
                        - FINES
                      </div>
                      <div style={{ width: "95%", marginBottom: 10 }}>
                        - TYRE'S, EXHAUST
                      </div> */}
                    </div>
                    <BaseButtons
                      label={"MORE DETAILS"}
                      backgroundColor={colors.greenDark}
                      width={"100%"}
                      borderRadius={8}
                      onClick={() => navigate("/agency-breakdown")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BecomeAgent;
